import { Injectable, inject } from '@angular/core';
import { IUserLogin } from '@auth/login/data/login.model';
import { SessionFacade } from '@shared/store/session.facade';

enum MessageKeys {
  LOGGED_IN = 'EOP_LOGGED_IN',
  LOGGED_OUT = 'EOP_LOGGED_OUT',
}

@Injectable({
  providedIn: 'root',
})
export class StorageBroadcastService {
  private readonly sessionFacade = inject(SessionFacade);

  public start() {
    window.addEventListener('storage', this.storageEventListener.bind(this));
  }

  /**
   * Broadcast the login event to all other open tabs of the browser
   * to prevent multiple user logins in the browser
   */
  public broadcastLogin(userLogin: IUserLogin) {
    localStorage.setItem(MessageKeys.LOGGED_IN, JSON.stringify(userLogin));
    localStorage.removeItem(MessageKeys.LOGGED_IN);
  }

  /**
   * Broadcast the logout event to all other open tabs of the browser
   * to prevent multiple user logins in the browser
   */
  public broadcastLogout() {
    localStorage.setItem(MessageKeys.LOGGED_OUT, MessageKeys.LOGGED_OUT);
    localStorage.removeItem(MessageKeys.LOGGED_OUT);
  }

  private storageEventListener(event: StorageEvent) {
    switch (event.key) {
      case MessageKeys.LOGGED_IN:
        if (!event.newValue) break; // removeItem is also throwing an event
        const userLogin: IUserLogin = JSON.parse(event.newValue);
        if (!userLogin) break;
        this.sessionFacade.loginSuccess(userLogin);
        break;
      case MessageKeys.LOGGED_OUT:
        if (!event.newValue) break; // removeItem is also throwing an event
        this.sessionFacade.logoutFromBroadcast();
        break;
    }
  }
}
